<template>
  <div class="con clearfix">
    <img
      class="return_icon"
      src="@/assets/product/icon_return_goods.png"
      alt=""
    />
    <div class="left font12 font_weight400 colo087 color_select">
      {{ mallretailspu.perspectiveView || "" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BuyerReviews",
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.con {
  padding: 7px 0 6px;
  border-top: 0.5px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  .return_icon {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    margin-right: 20px;
  }
  .color_select {
    line-height: 17px;
    margin: 4px 20px 0 0;
  }
}
</style>
